const OPEN_WEBVIEW_SCHEME = 'network.kasa.exchange://webview/landing?needsession=true&url=';
const CLOSE_SCHEME = 'network.kasa.exchange://in-site/close';
const SIGNUP_SCHEME = 'network.kasa.exchange://signup/suggest';

export const openWebView = (url: string) => {
  const encodedScheme = encodeURIComponent(url);
  document.location.href = `${OPEN_WEBVIEW_SCHEME}${encodedScheme}`;
};

export const closeScheme = () => {
  document.location.href = CLOSE_SCHEME;
};

export const signUpScheme = () => {
  document.location.href = SIGNUP_SCHEME;
};
